import React, { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * OvernightPanel — "What did Raw Company do while I was asleep?"
 * Shows every autonomous task logged in the last 12 hours, grouped by app.
 */
export default function OvernightPanel({ dismiss }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.get("/jarvis/overnight")
      .then(r => setData(r.data))
      .catch(e => setErr(e.response?.data?.detail || e.message));
  }, []);

  if (err) {
    return (
      <div className="stage-in rc-panel relative p-5 max-w-3xl w-full" data-testid="stage-overnight">
        {dismiss && <button onClick={dismiss} className="absolute top-2 right-2 text-[var(--rc-gold)]">×</button>}
        <div className="text-sm text-red-400">⚠ {err}</div>
      </div>
    );
  }
  if (!data) return <div className="stage-in rc-panel p-5">Reviewing the overnight log…</div>;
  const byApp = data.by_app || {};
  const keys = Object.keys(byApp).sort();
  return (
    <div className="stage-in rc-panel relative p-5 max-w-3xl w-full" data-testid="stage-overnight">
      {dismiss && (
        <button onClick={dismiss} className="absolute top-2 right-2 text-[var(--rc-gold)] hover:rc-glow-text text-lg" data-testid="dismiss-overnight">×</button>
      )}
      <div className="font-display tracking-widest text-[var(--rc-gold)] rc-glow-text uppercase text-sm mb-3">
        // OVERNIGHT REPORT · {data.total} TASKS · LAST 12H
      </div>
      {data.total === 0 && (
        <div className="text-sm opacity-70 py-6 text-center">
          Quiet night, sir. No autonomous tasks needed action.
        </div>
      )}
      <div className="space-y-4 max-h-[480px] overflow-y-auto pr-2">
        {keys.map((k) => (
          <div key={k} data-testid={`overnight-group-${k}`}>
            <div className="rc-label text-[10px] mb-1.5 sticky top-0 bg-[var(--rc-panel-bg,rgba(0,0,0,0.85))] py-1">
              {k.toUpperCase()} · {byApp[k].length}
            </div>
            <div className="space-y-1">
              {byApp[k].map((t, i) => (
                <div key={i} className="border-l-2 border-[var(--rc-gold)] pl-3 py-1" data-testid={`overnight-row-${k}-${i}`}>
                  <div className="text-xs">{t.title}</div>
                  {t.detail && <div className="text-[10px] opacity-60 mt-0.5">{t.detail.slice(0, 200)}</div>}
                  <div className="text-[9px] opacity-40 mt-0.5">{(t.created_at || "").replace("T", " ").slice(0, 16)}</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
